import NotificationList from "./pages/ListPage.vue";
import NotificationDetail from "./pages/FormPage.vue";
import NotificationIndex from "./pages/IndexPage.vue";
import NotificationInbox from "./pages/InboxPage.vue";

export default [
  {
    path: "/notification",
    component: NotificationIndex,
    redirect: "/notification/list",
    name: "notification",
    children: [
      {
        path: "list",
        component: NotificationList,
        name: "notification.list",
      },
      {
        path: "create",
        component: NotificationDetail,
        name: "notification.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: NotificationDetail,
        name: "notification.edit",
        props: { create: false },
      },
      {
        path: "inbox",
        component: NotificationInbox,
        name: "notification.inbox",
      },
    ],
  },
];
